/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  DeleteUserRequest,
  GetUsersByLocationsRequest,
  GetUsersByLocationsResponse,
  KeycloakResponse,
  PageResponseUserInfo,
  RoleRepresentation,
  UserAvatarRequest,
  UserDeletedResponse,
  UserImpersonateRequest,
  UserInfo,
  UserRequestData,
  UsersRequest,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Users<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags user-controller
   * @name AddUser
   * @request POST:/users
   * @secure
   * @response `200` `UserInfo` OK
   */
  addUser = (data: UserRequestData, params: RequestParams = {}) =>
    this.request<UserInfo, any>({
      path: `/users`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags user-controller
   * @name GenerateShareableLink
   * @request GET:/users/impersonation
   * @secure
   * @response `200` `Record<string,string>` OK
   */
  generateShareableLink = (params: RequestParams = {}) =>
    this.request<Record<string, string>, any>({
      path: `/users/impersonation`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags user-controller
   * @name ImpersonateUser
   * @request POST:/users/impersonation
   * @secure
   * @response `200` `Record<string,KeycloakResponse>` OK
   */
  impersonateUser = (
    data: UserImpersonateRequest,
    params: RequestParams = {},
  ) =>
    this.request<Record<string, KeycloakResponse>, any>({
      path: `/users/impersonation`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags user-controller
   * @name AllUsers
   * @request POST:/users/getUsers
   * @secure
   * @response `200` `PageResponseUserInfo` OK
   */
  allUsers = (data: UsersRequest, params: RequestParams = {}) =>
    this.request<PageResponseUserInfo, any>({
      path: `/users/getUsers`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags user-controller
   * @name GetPermissions
   * @request POST:/users/getPermissions
   * @secure
   * @response `200` `(RoleRepresentation)[]` OK
   */
  getPermissions = (params: RequestParams = {}) =>
    this.request<RoleRepresentation[], any>({
      path: `/users/getPermissions`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags user-controller
   * @name GetLevels
   * @request POST:/users/getLevels
   * @secure
   * @response `200` `Record<string,(RoleRepresentation)[]>` OK
   */
  getLevels = (params: RequestParams = {}) =>
    this.request<Record<string, RoleRepresentation[]>, any>({
      path: `/users/getLevels`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags user-controller
   * @name GetUsersByLocations
   * @request POST:/users/getByLocations
   * @secure
   * @response `200` `GetUsersByLocationsResponse` OK
   */
  getUsersByLocations = (
    data: GetUsersByLocationsRequest,
    params: RequestParams = {},
  ) =>
    this.request<GetUsersByLocationsResponse, any>({
      path: `/users/getByLocations`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags user-controller
   * @name ShowUser
   * @request GET:/users/{userId}
   * @secure
   * @response `200` `UserInfo` OK
   */
  showUser = (userId: string, params: RequestParams = {}) =>
    this.request<UserInfo, any>({
      path: `/users/${userId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags user-controller
   * @name DisableUser
   * @request DELETE:/users/{userId}
   * @secure
   * @response `200` `UserInfo` OK
   */
  disableUser = (userId: string, params: RequestParams = {}) =>
    this.request<UserInfo, any>({
      path: `/users/${userId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags user-controller
   * @name UpdateUser
   * @request PATCH:/users/{userId}
   * @secure
   * @response `200` `UserInfo` OK
   */
  updateUser = (
    userId: string,
    data: UserRequestData,
    params: RequestParams = {},
  ) =>
    this.request<UserInfo, any>({
      path: `/users/${userId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags user-controller
   * @name GetUserAvatar
   * @request GET:/users/{userId}/avatar
   * @secure
   * @response `200` `File` OK
   */
  getUserAvatar = (userId: string, params: RequestParams = {}) =>
    this.request<Blob, any>({
      path: `/users/${userId}/avatar`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags user-controller
   * @name UpdateUserAvatar
   * @request PATCH:/users/{userId}/avatar
   * @secure
   * @response `200` `UserInfo` OK
   */
  updateUserAvatar = (
    userId: string,
    data: UserAvatarRequest,
    params: RequestParams = {},
  ) =>
    this.request<UserInfo, any>({
      path: `/users/${userId}/avatar`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags user-controller
   * @name GetCurrentUserGuide
   * @request GET:/users/me/guide
   * @secure
   * @response `200` `string` OK
   */
  getCurrentUserGuide = (params: RequestParams = {}) =>
    this.request<string, any>({
      path: `/users/me/guide`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags user-controller
   * @name UpdateUserGuide
   * @request PATCH:/users/me/guide
   * @secure
   * @response `200` `string` OK
   */
  updateUserGuide = (data: string, params: RequestParams = {}) =>
    this.request<string, any>({
      path: `/users/me/guide`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags user-controller
   * @name GetCurrentUserAvatar
   * @request GET:/users/me/avatar
   * @secure
   * @response `200` `File` OK
   */
  getCurrentUserAvatar = (params: RequestParams = {}) =>
    this.request<Blob, any>({
      path: `/users/me/avatar`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags user-controller
   * @name UpdateUserAvatarForCurrentUser
   * @request PATCH:/users/me/avatar
   * @secure
   * @response `200` `UserInfo` OK
   */
  updateUserAvatarForCurrentUser = (
    data: UserAvatarRequest,
    params: RequestParams = {},
  ) =>
    this.request<UserInfo, any>({
      path: `/users/me/avatar`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags user-controller
   * @name GetUserPermissions
   * @request GET:/users/{userId}/permissions
   * @secure
   * @response `200` `(RoleRepresentation)[]` OK
   */
  getUserPermissions = (userId: string, params: RequestParams = {}) =>
    this.request<RoleRepresentation[], any>({
      path: `/users/${userId}/permissions`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags user-controller
   * @name Me
   * @request GET:/users/me
   * @secure
   * @response `200` `UserInfo` OK
   */
  me = (params: RequestParams = {}) =>
    this.request<UserInfo, any>({
      path: `/users/me`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags user-controller
   * @name DeleteUser
   * @request DELETE:/users/{userId}/archive
   * @secure
   * @response `200` `UserDeletedResponse` OK
   */
  deleteUser = (
    userId: string,
    data: DeleteUserRequest,
    params: RequestParams = {},
  ) =>
    this.request<UserDeletedResponse, any>({
      path: `/users/${userId}/archive`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}
